import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';

// mui
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton'

// redux
import { useAppDispatch, useAppSelector } from '../../hooks'
import { getFundraisingAmbassadors, removeFundraisingAmbassador } from '../../managers/redux/slices/fundraising'
import { reloadAuthAccount } from '../../managers/redux/slices/authAccount'
import InviteTeamMember from '../../components/dialogs/team/InviteTeamMember'
import { COLORS } from '../../theme/muiTheme';

import { FundraisingCampaign, FundraisingCampaignAmbassador, FundraisingProfile } from '../../API'
import InviteAmbassador from '../../components/dialogs/fundraising/InviteAmbassador';
import { Drawer } from '@mui/material';
import ProfileAvatar from '../../components/data-display/ProfileAvatar';
import { Close } from '@mui/icons-material';
import { API } from 'aws-amplify';
import { listFundraisingCampaignAmbassadorsByFundraisingProfile } from '../../managers/graphql/queries';

export default function Ambassadors(props: any) {

    const history = useHistory()

    // redux
    const dispatch = useAppDispatch()
    const fundraising = useAppSelector(state => state.fundraising)
    const authAccount = useAppSelector(state => state.authAccount)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    // dialog
    const [showStaffInvitationDialog, setShowStaffInvitationDialog] = useState(false)

    // drawer
    const [showAmbassadorDrawer, setShowAmbassadorDrawer] = useState<boolean>(false)
    const [selectedAmbassadorDrawerAmbassador, setSelectedAmbassadorDrawerAmbassador] = useState<FundraisingProfile | null>(null)
    const [selectedAmbassadorDrawerAmbassadorCampaigns, setSelectedAmbassadorDrawerAmbassadorCampaigns] = useState<(FundraisingCampaignAmbassador | null)[]>([])

    useEffect(() => {
        (async () => {
            if (authAccount.cognitoData) {
                if (fundraising.ambassadors == null) {
                    dispatch(getFundraisingAmbassadors())
                }
            } else {
                await dispatch(reloadAuthAccount())
                if (fundraising.ambassadors == null) {
                    dispatch(getFundraisingAmbassadors())
                }
            }
        })()
    }, [])

    function handleDrawerClose() {
        setShowAmbassadorDrawer(false)
        setSelectedAmbassadorDrawerAmbassador(null)
    }

    async function handleDrawerOpen(fundraisingProfile: FundraisingProfile) {
        setSelectedAmbassadorDrawerAmbassador(fundraisingProfile)
        setShowAmbassadorDrawer(true)
        const { data }: any = await API.graphql({
            query: listFundraisingCampaignAmbassadorsByFundraisingProfile,
            variables: {
                fundraisingProfileID: fundraisingProfile.id
            }
        })
        setSelectedAmbassadorDrawerAmbassadorCampaigns(data.listFundraisingCampaignAmbassadorsByFundraisingProfile.items)
    }

    return (
        <div className="p-5 d-flex flex-column justify-content-start row">
            <div className="col-12 border rounded bg-white mb-4 p-5">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className="d-flex flex-column justify-content-center align-items-start">
                        <Typography variant="h4">Invitation Codes</Typography>
                        <Typography variant="body1">Invitation codes are created by your organization for use by multiple ambassadors.</Typography>
                    </div>
                    <Button variant="contained" onClick={() => history.push('/admin/invitation-codes')}>Manage Invitation Codes</Button>
                </div>
            </div>
            <div className="d-flex flex-row justify-content-between w-100 mb-3">
                <Typography variant="h3">{fundraising && fundraising.ambassadors ? fundraising.ambassadors.length : ''} {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverridePlural ? selectedStaffProfile.organization.ambassadorTermOverridePlural : 'Ambassadors'}</Typography>
                <Button
                    onClick={() => {
                        setShowStaffInvitationDialog(true)
                    }}
                >
                    Invite {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'}
                </Button>
            </div>

            <TableContainer component={Paper} className="px-0">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center"></TableCell>
                            <TableCell align="left">First Name</TableCell>
                            <TableCell align="left">Last Name</TableCell>
                            <TableCell align="left">Email</TableCell>
                            <TableCell align="left">Added</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            fundraising && fundraising.ambassadors && fundraising.ambassadors.length > 0 ?
                                fundraising.ambassadors.map((fundraisingProfile: FundraisingProfile) => {
                                    if (fundraisingProfile && fundraisingProfile.authAccount) {
                                        return (
                                            <TableRow
                                                key={fundraisingProfile.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: COLORS.ICE } }}
                                                onClick={() => { handleDrawerOpen(fundraisingProfile) }}
                                            >
                                                <TableCell align="center" style={{ width: 50 }}>
                                                    <ProfileAvatar size="medium" authAccountID={fundraisingProfile && fundraisingProfile.authAccount ? fundraisingProfile.authAccount.id : null} />
                                                </TableCell>
                                                <TableCell align="left">
                                                    {fundraisingProfile && fundraisingProfile.authAccount && fundraisingProfile.authAccount.firstName ? fundraisingProfile.authAccount.firstName : 'Not added'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {fundraisingProfile && fundraisingProfile.authAccount && fundraisingProfile.authAccount.lastName ? fundraisingProfile.authAccount.lastName : 'Not added'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {fundraisingProfile && fundraisingProfile.authAccount && fundraisingProfile.authAccount.primaryEmail ? fundraisingProfile.authAccount.primaryEmail : 'Not added'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {fundraisingProfile && fundraisingProfile.authAccount && fundraisingProfile.authAccount.createdAt ? new Date(fundraisingProfile.authAccount.createdAt).toLocaleString() : 'Not added'}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    } else {
                                        return (
                                            <TableRow
                                                key={fundraisingProfile.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: COLORS.ICE } }}
                                                onClick={() => { setSelectedAmbassadorDrawerAmbassador(fundraisingProfile); setShowAmbassadorDrawer(true) }}
                                            >
                                                <TableCell align="left">

                                                </TableCell>
                                                <TableCell align="left">

                                                </TableCell>
                                                <TableCell align="left">
                                                    {fundraisingProfile && fundraisingProfile.email ? fundraisingProfile.email : 'Not added'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    Invited
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                })
                                :
                                <div></div>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Drawer
                open={showAmbassadorDrawer}
                onClose={handleDrawerClose}
                anchor="right"
            >
                {
                    selectedAmbassadorDrawerAmbassador &&
                    <div className='bg-light p-5 row w-100'>
                        <div className="col-12 d-flex flex-row justify-content-end align-items-center w-100">
                            <IconButton onClick={handleDrawerClose}>
                                <Close sx={{ color: 'black' }} />
                            </IconButton>
                        </div>
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center mb-5">
                            <ProfileAvatar authAccountID={selectedAmbassadorDrawerAmbassador && selectedAmbassadorDrawerAmbassador.authAccountID ? selectedAmbassadorDrawerAmbassador.authAccountID : null} size={100} />
                        </div>
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <Typography variant="h3">
                                {selectedAmbassadorDrawerAmbassador && selectedAmbassadorDrawerAmbassador.authAccount && selectedAmbassadorDrawerAmbassador.authAccount.firstName ? selectedAmbassadorDrawerAmbassador.authAccount.firstName : 'Not added'} {selectedAmbassadorDrawerAmbassador && selectedAmbassadorDrawerAmbassador.authAccount && selectedAmbassadorDrawerAmbassador.authAccount.lastName ? selectedAmbassadorDrawerAmbassador.authAccount.lastName : 'Not added'}
                            </Typography>
                        </div>
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <Typography variant="h5">
                                {selectedAmbassadorDrawerAmbassador && selectedAmbassadorDrawerAmbassador.email ? selectedAmbassadorDrawerAmbassador.email : 'Email not added'}
                            </Typography>
                        </div>
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <Typography variant="body1">Connected to {selectedAmbassadorDrawerAmbassador && selectedAmbassadorDrawerAmbassador.campaigns && selectedAmbassadorDrawerAmbassador.campaigns.items.length > 0 ? selectedAmbassadorDrawerAmbassador.campaigns.items.length : 0} campaigns</Typography>
                            {
                                selectedAmbassadorDrawerAmbassadorCampaigns ?
                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3">
                                        <Typography variant="h5">Campaigns:</Typography>
                                        {
                                            selectedAmbassadorDrawerAmbassadorCampaigns.map((campaign: FundraisingCampaignAmbassador | null) => {
                                                return (
                                                    <Typography>{campaign && campaign.fundraisingCampaign ? campaign.fundraisingCampaign.campaignName : ''}{campaign && campaign.fundsRaised ? ` - $${Number(campaign.fundsRaised / 100)} raised` : ''}</Typography>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <div></div>
                            }
                        </div>
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center my-5">
                            <Typography variant="h4">Actions</Typography>
                        </div>
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <Button color="error" variant="outlined" onClick={() => {
                                dispatch(removeFundraisingAmbassador({ fundraisingProfile: selectedAmbassadorDrawerAmbassador }))
                                handleDrawerClose()
                            }}>Disconnect from your organization</Button>
                        </div>
                    </div>
                }
            </Drawer>

            {/* DIALOG */}
            <InviteAmbassador visible={showStaffInvitationDialog} onClose={() => setShowStaffInvitationDialog(false)} />

        </div>
    )
}